"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackbarMessage = SnackbarMessage;

var _message = require("../message");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * `StyledMessage` styled component.
 */
var StyledMessage = (0, _styledComponents["default"])(_message.Message).withConfig({
  displayName: "snackbar-message__StyledMessage",
  componentId: "sc-9169m0-0"
})(["margin-bottom:8px;"]);
/**
 * Export `SnackbarMessage` component.
 */

function SnackbarMessage(props) {
  var children = props.children,
      id = props.id,
      onRemove = props.onRemove,
      options = props.options;

  var _ref = options !== null && options !== void 0 ? options : {},
      _ref$hasTimeout = _ref.hasTimeout,
      hasTimeout = _ref$hasTimeout === void 0 ? true : _ref$hasTimeout,
      timeoutValue = _ref.timeout;

  var handleCloseMessage = (0, _react.useCallback)(function () {
    onRemove(id);
  }, [id, onRemove]);
  (0, _react.useEffect)(function () {
    if (hasTimeout) {
      var timeout = setTimeout(function () {
        onRemove(id);
      }, timeoutValue !== null && timeoutValue !== void 0 ? timeoutValue : 3000);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [hasTimeout, id, onRemove, options, timeoutValue]);
  return /*#__PURE__*/_react["default"].createElement(StyledMessage, _extends({}, options, {
    onClose: handleCloseMessage
  }), children);
}